import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initAnalytics } from './utils/analytics';

// Vang het install-event vroeg op, ook als React nog niet gemount is.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.deferredPWAEvent = e as never;
});

// De service worker wordt door vite-plugin-pwa geregistreerd (zie UpdateToast).
// Laadt Google Analytics alleen als de bezoeker eerder toestemming gaf.
initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
